/* eslint-disable */
import {CLINICAL_TRIALS_GOV_URL} from './../../../constants'
import React, { useState } from "react";
import { Table, Row, Col, Select, Button, Spin, Slider, Input, Switch, Tabs, Radio, Tooltip } from "antd";
import { listStudy, getTrialPresets } from "../../../utils/ajax-proxy";
import { calculateMean, getListBypropName, getPageForKey, percentile, sortList } from '../../../utils/utils';
import { connect } from "react-redux";
import ReactECharts from "echarts-for-react";
import { SearchOutlined, FilterOutlined, CloseOutlined, InfoCircleOutlined } from '@ant-design/icons';
import * as createActions from "../../../actions/createTrial.js";
import * as historyActions from "../../../actions/historyTrial";
import { roundToTwoDecimals } from "../../../utils/utils"
import "./index.scss";
const { TabPane } = Tabs;

const { Option } = Select;

const getClinicalTrialsGovURL = (nctID) => {
    const regexPattern = /^NCT\d{8}$/;
    if(regexPattern.test(nctID)){
        return CLINICAL_TRIALS_GOV_URL+nctID
    }
  };

const changeTrialFormat = (nctID) => {
  if (nctID.startsWith("NCT-")) {
    return nctID.substring(4);
  } else {
    return nctID;
  }
}

const columns = [
  {
    title: "Study id",
    dataIndex: "nct_id",
    ellipsis: true,
    render: (nctId, record) => <a href={getClinicalTrialsGovURL(nctId)} target="_blank" title={record.brief_title}>{changeTrialFormat(nctId)}</a>,
    width: 140,
  },
  {
    title: "Sponsor",
    dataIndex: "sponsor",
    ellipsis: true,
  },
  {
    title: "Indication",
    dataIndex: "indication",
    ellipsis: true,
    render: indication => indication && indication.join("; "),
  },
  {
    title: "Phase",
    dataIndex: "study_phase",
    ellipsis: true,
    width: 120,
  },
  {
    title: "MoA",
    dataIndex: "moa_data",
    ellipsis: true,
    render: moa_data => moa_data && moa_data.join("; "),
  },
  {
    title: "Status",
    dataIndex: "study_status",
    ellipsis: true,
    width: 170,
  },
  {
    title: "SoA",
    dataIndex: "soa_status_flag",
    ellipsis: true,
    width: 80,
    },
  {
    title: "Start date",
    dataIndex: "start_date",
    ellipsis: true,
    width: 173,
    },
  {
    title: "Pediatric",
    dataIndex: "pediatric",
    ellipsis: true,
    width: 110,
  },
];

interface HistoricalProps {
  createTrial?: any;
  newTrial?: any;
  indicationList?: any;
  shouldFetch?: boolean;
  fetchHistory?: any;
  historyTrial?:any;
  handleNewTrialSelectChangeHistory?:any;
  studyPhaseList?:any;
  studyTypeList?:any;
  studyStatusList?:any;
  selectedSOA?:any,
  resetTrials?:any;
  resetTrialsCount?:any;
  isUpdate: boolean;
  moaList?:any;
  loadMoaData?:any;
  patientSegmentList?:any;
  metricsData?:any;
  patientSegmentData?:any;
  selectedMoaData?:any;
  indicationTherapeuticMap?:any;
  isSaveTrial?:boolean;
  isCycleBased?:boolean;
  getPresets?:any;
  presetsData?:any;
  filterTabChange?:any;
  isFilterTab?:any;
  saveStatusReset?:any;
  savedPreset?:any
}
const min = 2010;
const max = 2025;
const marks = {
  2010: "2010",
  2015: "2015",
  2020: "2020",
  2025: "2025",
};

const sponsorChartColor =[
    // "#d04a02",
    // "#d4520d",
    // "#d85d1c",
    // "#de6c30",
    // "#e47d47",
    // "#e68d5e",
    // "#e8aa89", 
  "#D04A02",
  "#EB8C00",
  "#FFB600",
  "#7D7D7D",
  "#DEDEDE",
  "#295477",
  "#299D8F",
  "#4577C9",
  "#00C6F7",
  "#3DD5B0",
  "#D93954",
  "#657DFF",
  "#E72B33"


    // "#6F2849",
    // "#9C3F5D",
    // "#C8586C",
    // "#DC7075",
    // "#B13E64",
    // "#CA5268",
    // "#DC676C",
    // "#EA8170", 
    // "#F19B7C",
    // "#F5B68D",
    // "#F6D1A9",
    // "#FBE5C4"
]
const statusChartColor=[
  // "#d04a02",
  // "#d4520d",
  // "#d85d1c",
  // "#de6c30",
  // "#e47d47",
  // "#e68d5e",
  // "#e8aa89"

  "#D04A02",
  "#EB8C00",
  "#FFB600",
  "#7D7D7D",
  "#DEDEDE",
  "#295477",
  "#299D8F",
  "#4577C9",
  "#00C6F7",
  "#3DD5B0",
  "#D93954",
  "#657DFF",
  "#E72B33"


  // "#462B2F",
  // "#6B343D",
  // "#903F4D",
  // "#B5485B",
  // "#773829",
  // "#A7452C",
  // "#C34C2F",
  // "#C27606",
  // "#EB8C00",
  // "#BC8609",
  // "#DD9B04",
  // "#FFB600"

  // "#6F2849",
  // "#9C3F5D",
  // "#C8586C",
  // "#DC7075",
  // "#B13E64",
  // "#CA5268",
  // "#DC676C",
  // "#EA8170",  
  // "#F19B7C",
  // "#F5B68D",
  // "#F6D1A9",
  // "#FBE5C4"
]
class SimilarHistoricalTrial extends React.Component<HistoricalProps> {
  constructor(props: HistoricalProps) {
    super(props);
    this.onFindTrials = this.onFindTrials.bind(this);
    this.onCloseFilter = this.onCloseFilter.bind(this)
  }
  inputRefs = {}; 

  trialData = Object.keys(JSON.parse(localStorage.getItem('newTrial'))).length !== 0 && JSON.parse(localStorage.getItem('newTrial'))|| this.props.newTrial;
  
  temp_studyPhase= this.props.isUpdate? this.trialData.saved_filters.study_phase : this.trialData.study_phase || []
  
  temp_studyType =  this.props.isUpdate? this.trialData.saved_filters.study_type : this.trialData?.study_type || []
  
  temp_studyStatus = this.trialData.saved_filters.study_status.length > 0 || this.props.isUpdate? this.trialData.saved_filters.study_status : this.trialData.study_status || []
  
  temp_indication = this.trialData.indication.length + this.trialData.saved_filters.indication === 0 ? [] : this.props.isUpdate? this.trialData.saved_filters.indication : this.trialData.indication
  // temp_indication = this.trialData.indication.length + this.trialData.saved_filters.indication === 0 ? [] : this.trialData.indication

  temp_soaFlag = this.trialData.saved_filters?.soa  || this.props.isUpdate? this.trialData.saved_filters.soa  ?this.trialData.saved_filters.soa: null : this.trialData.soa_status_flag|| null
  temp_pediatric = this.trialData.saved_filters?.pediatric || this.props.isUpdate? this.trialData.saved_filters?.pediatric : this.setPediatricTrial(this.trialData.pediatric_study) || null

  temp_selectedMoa = this.trialData.saved_filters.moa.length > 0 || this.props.isUpdate? this.trialData.saved_filters.moa : this.props.selectedMoaData || []

  temp_dateFrom = this.trialData.saved_filters?.study_start_date[0] !== 2010 || this.props.isUpdate? this.trialData.saved_filters.study_start_date[0] : this.trialData.dateFrom || 2010

  temp_dateTo = this.trialData.saved_filters?.study_start_date[1] !== 2025 || this.props.isUpdate? this.trialData.saved_filters.study_start_date[1] : this.trialData.dateTo || 2025

  temp_toggle = this.trialData.saved_filters?.toggle || this.props.isUpdate? this.trialData.saved_filters.toggle : this.trialData.toggle_indication || false

  temp_patient_segment = this.trialData.saved_filters.patient_segment?.length > 0 || this.props.isUpdate? this.trialData.saved_filters.patient_segment : this.props.patientSegmentData || []

  state = {
    current: 1,
    pageSize: 5,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
    sideBar: 6,
    showFilter: true,
    studyType: this.temp_studyType,
    studyPhase: this.temp_studyPhase,
    studyStatus: this.temp_studyStatus,
    indication: this.temp_indication,
    pediatric: this.temp_pediatric,
    dateFrom: this.temp_dateFrom,
    dateTo: this.temp_dateTo,
    selectedRowKeys: this.trialData.similarHistoricalTrials && this.trialData.similarHistoricalTrials.length !== 0 ? this.trialData.similarHistoricalTrials : [],
    selectedRowKeysByPage: {},
    selectedPages:[],
    spinning: false,
    isCleared: false,
    data: [],
    rawData: this.props.historyTrial.historyData,
    statusChartData: [],
    sponsorChartData: [],
    optionOne: {},
    optionTwo: {},
    showStatusChart:true,
    indicationError:"",
    soaFlag: this.temp_soaFlag,
    soaData: [],
    moaDataList: this.props.moaList,
    patientSegmentDataList: this.props.patientSegmentList,
    metricsDataList: [],
    selectedMoa: this.temp_selectedMoa,
    selectedPs: this.temp_patient_segment,
    indicationList: this.props.indicationList.length === 0?this.trialData.indicationList:this.props.indicationList,
    searchValues: {
      nct_id: '',
      sponsor: '',
      indication: '',
      study_phase: '',
      moa_data: '',
      study_status: '',
      soa_status_flag: '',
      start_date: '',
      pediatric: '',
    },
    searchedData: [],
    searchedRawData: [],
    lastChangedInput: '',
    saved_filters: {
      study_phase: this.temp_studyPhase,
        study_type: this.temp_studyType,
        indication: this.temp_indication,
        study_status: this.temp_studyStatus,
        study_start_date: [this.temp_dateFrom, this.temp_dateTo],
        moa: this.temp_selectedMoa,
        pediatric: this.temp_pediatric,
        soa: this.temp_soaFlag,
        toggle: this.temp_toggle,
        patient_segment: this.temp_patient_segment
    }, 
    toggle_indication: this.temp_toggle,
    cycle_based: this.props.isCycleBased? this.props.isCycleBased:this.trialData.cycle_based_trial_flag,
    isPresetsTabSelected: false,
    presetList: [],
    checkedPreset: null,
    selectedPreset: [],
    shouldAutoFocus: null,
    metrics_data_list: {
      patients_per_site_per_month: 0, 
      number_of_sites: 0, 
      enrollment_count: 0, 
      enrollment_duration: 0, 
      number_of_countries: 0, 
    },
    activeTab: "1",
    tooltip_visibility: {
      siteTooltipVisible: false,
      patientTooltipVisible: false,
      countryTooltipVisible: false,
      enrollmentDurationTooltipVisible: false,
      enrollmentSpeedTooltipVisible: false,

    }
    
  };


  componentDidMount() {
    this.onFindTrials(false)
    // let therapeuticAreaVal =this. trialData["therapeutic_area"]
    const sortIndication = (indicationList) => {
      return indicationList&&indicationList.sort((ind1, ind2) => (ind1.label < ind2.label) ? -1 : (ind1.label > ind2.label) ? 1 : 0);
    }
    this.setState({
        indicationList: sortIndication(this.props.indicationList)
      });
    const storedTrial = JSON.parse(localStorage.getItem('newTrial'));
    if (storedTrial && storedTrial.similarHistoricalTrials) {
      const selectedRowKeys = storedTrial.similarHistoricalTrials;
      const selectedRowKeysByPage = selectedRowKeys.reduce((acc, key) => {
        const page = getPageForKey(key); 
        if (!acc[page]) {
          acc[page] = [];
        }
        acc[page].push(key);
        return acc;
      }, {});
      const selectedPages = Object.keys(selectedRowKeysByPage);
      this.setState({
        selectedRowKeys,
        selectedRowKeysByPage,
        selectedPages,
      });
      
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectedRowKeys !== this.state.selectedRowKeys) {
      this.soaHandler(this.state.rawData)
    }    
    if(prevProps.isSaveTrial !== this.props.isSaveTrial) {
      this.setState({
        spinning: true
      });
    }
    if(prevProps.savedPreset !== this.props.savedPreset && this.props.savedPreset == true) {
      this.handlePresetsTab('2', true)
    }
    localStorage.setItem('newTrial', JSON.stringify(JSON.parse(localStorage.getItem('newTrial'))))
  }

  setPediatricTrial(val) {
    if (typeof val !== 'string') {
      return val;
    }

    if (val === 'null') {
      return null;
    }

    return val === 'true';
  }

  getChartData(datasource, key) {
    let keyValues = [];
    datasource.forEach((e) => {
      keyValues.push(e[key]);
    });
    keyValues = Array.from(new Set(keyValues));
    const pieChartData = [];
    keyValues.forEach((v) => {
      const values = datasource.filter(
        (d) => d[key].toLowerCase() == v.toLowerCase()
      );
      pieChartData.push({
        value: values.length,
        name: v,
      });
    });
    return pieChartData;
  }

  handlePresetsTab = (key, isSave = false) => {
    this.setState({ shouldAutoFocus: false, activeTab: key})

    const { checkedPreset } = this.state;  
    const { getPresets } = this.props;  
    this.onFindTrials(false, false, true);  
    this.setState({ isPresetsTabSelected: true });
    if (checkedPreset && !isSave) {  
      this.getStudyByPresetId(checkedPreset);
      const selectedPreset = getPresets?.filter(preset => preset.preset_id === checkedPreset);  
      this.setState({ selectedPreset });
    } else {  
      const newCheckedPreset = getPresets[0]?.preset_id;  
      this.setState({ checkedPreset: newCheckedPreset, selectedPreset: newCheckedPreset });  
      if(!newCheckedPreset) return
      this.getStudyByPresetId(newCheckedPreset);  
    }  
  }

  resetFilterOnTabChange = () => {
    Object.entries(this.state.saved_filters).forEach(([key, value]) => {  
      switch (key) {  
          case 'indication':  
              this.setState({ indication: value });  
              break;  
          case 'study_status':  
              this.setState({ studyStatus: value });  
              break;  
          case 'study_type':  
              this.setState({ studyType: value });  
              break;  
          case 'study_phase':  
              this.setState({ studyPhase: value });  
              break;  
          case 'toggle':  
              this.setState({ toggle_indication: value });  
              break;  
          case 'soa':  
              this.setState({ soaFlag: value });  
              break;  
          case 'study_start_date':
              this.setState({ dateFrom: value[0], dateTo: value[1] });  
              break;  
          case 'pediatric':
            this.setState({ pediatric: value });  
            break; 
          case 'patient_segment':
            this.setState({ selectedPs: value });  
            break;  
          default:  
              break;  
      }  
    });  
  }

  handleTabChange = (key) => { 
    this.setState({ 
      shouldAutoFocus: false, 
      activeTab: key,  
      searchValues: {
        nct_id: '',
        sponsor: '',
        indication: '',
        study_phase: '',
        moa_data: '',
        study_status: '',
        soa_status_flag: '',
        start_date: '',
        pediatric: '',
      }})

    this.resetFilterOnTabChange()
    if (key === '2') {
      this.props.filterTabChange(false)
      this.handlePresetsTab(key)
    } else {  
      this.setState({ isPresetsTabSelected: false, selectedPreset: [] });  
      this.onFindTrials(true, true); 
      this.props.filterTabChange(true) 
    }  
  };  
  

  resetAutoFocus = () => {
    this.setState({shouldAutoFocus: false})
  }

  getStudyByPresetId = async (presetId) => {
    const response = await getTrialPresets("getTrialPresetValues", "preset_id", presetId)
    if(response) {
      this.setState({ selectedRowKeys:  response['preset_value_list']});
      this.onRowSelectChange(response['preset_value_list'], false)
    }
  }

  onChangePresets = async (evt) => {
    const value = evt.target.value
    this.setState({ checkedPreset: value })
    await this.getStudyByPresetId(value) 
    this.setState({ selectedPreset: this.props.getPresets?.filter( o => o.preset_id == value)})
    this.props.saveStatusReset(false)
  }

  changePage = (page) => {
    this.setState({
      current: page,
    });
  };

  onShowSizeChange = (current, pageSize) => {
    this.setState({
      current: current,
      pageSize: pageSize,
    });
  };

  onSelectChange = (key, v) => {
    this.setState({
      [key]: v,
    });
    
    if(key==="studyStatus") {
      let newValue
      if(v.length>1 && v.includes('All')) {
        if(v.indexOf('All')===0) {
          newValue = v.filter((item)=> {
            return item !== 'All'
          })
        this.setState({
          studyStatus: newValue,
        });
        } else {
          this.setState({
            studyStatus: ['All'],
          });
        }
      } else {
        this.setState({
          studyStatus: v,
        });
      }
    }
  };

  onDeselectChange = (key, v) => {
    if(key==="indication") {
      if(this.trialData.indication.length === 1) {
        if(this.trialData.indication.includes(v)) {
          this.setState({
            indication: [...this.state.indication],
          })          
          return;
        }
      } else if (this.trialData.indication.length > 1) {
        var newState = this.state.indication.filter(item => item !== v)      
        if (!newState.some(item => this.trialData.indication.includes(item))) {
          this.setState({
            indication: [...this.state.indication],
          })
          return;
        }
      }
    }
  }

  onClearChange = () => {

  }     

  loadSOEHandler = (historicalTrialKeys) => {
    this.setState({
      selectedRowKeys: historicalTrialKeys,
    })
    this.props.createTrial({
      similarHistoricalTrials: historicalTrialKeys, 
    });
    localStorage.setItem('newTrial',  JSON.stringify(Object.assign(JSON.parse(localStorage.getItem('newTrial')),{
      similarHistoricalTrials: historicalTrialKeys, 
    })))
    this.props.handleNewTrialSelectChangeHistory("similarHistoricalTrials", historicalTrialKeys)
  }

  handleLegendFormatter = (chartData, legenName) => {
    const sum = chartData.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.value
    }, 0)
    const targetVal = chartData.find(d => d.name == legenName).value
    let p = ((targetVal / sum) * 100).toFixed(2);
    return legenName + " - " + p + "%";
  }

  changeToggleHandler = (e) => {
    this.setState({
      toggle_indication: e,
    })
  }

  filterByIndication = (tempIndication, d) => { 
    if(this.state.toggle_indication) {
      return tempIndication.every(indication =>  d.indication_id.includes(indication));
    }

    let includesAllIndications = tempIndication.every(indication => d.indication_id.includes(indication)); 
    let noExtraIndications = d.indication_id.every(indication => tempIndication.includes(indication));  
    return includesAllIndications && noExtraIndications;
  }

  sameIndications = (trialIndications, stateIndications) => {
    return trialIndications.sort().toString() === stateIndications.sort().toString()
  }

  updateMetrics = (data) => {
    const statusData = this.getChartData(data, "study_status");
    const sponsorData = this.getChartData(data, "sponsor");
    const soaSelectedData = data.filter(k => k.soa_status_flag.toUpperCase() == 'YES');
    this.setState({
      data: data,
      statusChartData: statusData,
      sponsorChartData: sponsorData,
      soaData: soaSelectedData
    });
    localStorage.setItem('SoaCount', soaSelectedData.length)
  }

  onFindTrials = async (eventListener, isFilter = true, isTabChange = false) => {
    if(!this.handleValidation("indication", null)){
        return false
    }
    if(isTabChange) return
    this.setState({
      spinning: true,
    })
    if (this.state.studyStatus) {
      this.setState({
        showStatusChart: true
      });
    }
    this.props.handleNewTrialSelectChangeHistory("saved_filters", Object.assign(this.state.saved_filters,{
      moa: this.state.selectedMoa,
      study_phase: this.state.studyPhase,
      study_type: this.state.studyType,
      pediatric: this.state.pediatric,
      indication: this.state.indication,
      soa: this.state.soaFlag,
      study_status: this.state.studyStatus,
      study_start_date: [this.state.dateFrom, this.state.dateTo],
      toggle: this.state.toggle_indication,
      patient_segment: this.state.selectedPs
    }))
    this.props.handleNewTrialSelectChangeHistory("dateFrom", this.state.dateFrom)
    this.props.handleNewTrialSelectChangeHistory("dateTo", this.state.dateTo)
    const resp = await listStudy(this.state.saved_filters);
    this.setState({
      spinning: false,
    });
      if (resp) {
      const moaData  = resp.moa_data_list;
      const patientSegmentData  = resp.patient_segment_data_list;
      this.props.loadMoaData(moaData, patientSegmentData)
      this.setState({
        moaDataList: moaData,
        patientSegmentDataList: patientSegmentData
      })
      const tmpData = resp.results?.map((d, idx) => {
        d.key = d["study_ref_id"];
        d.sponsor = d.sponsor || '';
        d.study_status = d.study_status || '';
        return d;
      })
      this.setState({
        rawData: tmpData,
      });
      this.props.fetchHistory({
        historyData: tmpData,
        shouldFetch: false
      })
      const filteredData = tmpData

      const historicalTrialKeys = this.props.isUpdate && !eventListener ? this.state.selectedRowKeys
                                            : filteredData?.map(item => item.key);
      if(historicalTrialKeys?.length >= 0) {
        this.loadSOEHandler(historicalTrialKeys);
      }
      this.updateMetrics(filteredData);
      this.soaHandler(filteredData);
      this.setState({
        searchedData: filteredData?.map((item) => ({
          ...item,
          pediatric: item.pediatric ? "YES" : "NO"
        })),
        searchedRawData: filteredData?.map((item) => ({
          ...item,
          pediatric: item.pediatric ? "YES" : "NO"
        })),
      });
      const updatedData = this.state?.searchedData?.length > 0 && !eventListener ? filteredData.filter(trial => this.state.selectedRowKeys.includes(trial.study_ref_id)): filteredData;
      this.calculateSummaryMetrics(updatedData);
    }
  };

  onCloseFilter = ( value ) => {
    this.setState({
      sideBar: value
    })
  }

  getOptionOne() {
    const optionOne = {
      title: {
        text: "By sponsor",
        x: "5%",
        y: "top",
        textStyle: {
          fontSize: 14,
        },
      },
      tooltip: {
        trigger: "item",
        formatter: function (params,idx) {
          const chartData = optionOne.legend.data
          const sum = chartData.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.value
          }, 0)
          let p = ((params.value / sum) * 100).toFixed(2);
          return params.name + " - " + p + "%";
        },
        position: ['5%', '10%'],
        textStyle:{
          fontSize: 12,
      },
        confine:false,
      },
      legend: {
        show:false,
        data: this.state.sponsorChartData
      //   x: "left",
      //   y: "60%",
      //   itemHeight: 7,
      //   textStyle: {
      //     fontSize: 8,
      //   },
      //   formatter: function (params) {
      //     const chartData = optionOne.series[0].data
      //     const sum = chartData.reduce((accumulator, currentValue) => {
      //      return accumulator + currentValue.value
      //     }, 0)
      //     const targetVal = chartData.find(d => d.name == params).value
      //     let p = ((targetVal / sum) * 100).toFixed(2);
      //     return params + " - " + p + "%";
      //   },
      },
      series: [
        {
          type: "pie",
          center: ["30%", "50%"],
          radius: ["20%", "40%"],
          avoidLabelOverlap: false,
          label: {
            show: false,
          },
          color: sponsorChartColor,
          data: this.state.sponsorChartData.sort((a, b) => {
            return b.value - a.value;
          })
          .slice(0, 10),
        },
      ],
    };
    return optionOne;
  }

  getOptionTwo() {
    const optionTwo = {
      title: {
        text: "By status",
        x: "5%",
        y: "top",
        textStyle: {
          fontSize: 14,
          fontWeight: "bold",
        },
      },
      tooltip: {
        trigger: "item",
        formatter: function (params,idx) {
          const chartData = optionTwo.legend.data
              const sum = chartData.reduce((accumulator, currentValue) => {
               return accumulator + currentValue.value
              }, 0)
              let p = ((params.value / sum) * 100).toFixed(2);
              return params.name + " - " + p + "%";
        },
        position: ['5%', '10%'],
        textStyle:{
          fontSize: 12,
      },
        confine:false,
      },
      legend: {
        show:false,
        data: this.state.statusChartData
      //   x: "left",
      //   y: "60%",
      //   itemHeight: 7,
      //   textStyle: {
      //     fontSize: 8,
      //   },
      //   formatter: function (params,idx) {
      //     const chartData = optionTwo.series[0].data
      //     const sum = chartData.reduce((accumulator, currentValue) => {
      //      return accumulator + currentValue.value
      //     }, 0)
      //     const targetVal = chartData.find(d => d.name == params).value
      //     let p = ((targetVal / sum) * 100).toFixed(2);
      //     return params + " - " + p + "%";
      //   },
      },
      series: [
        {
          type: "pie",
          center: ["30%", "50%"],
          radius: ["20%", "40%"],
          avoidLabelOverlap: false,
          label: {
            show: false,
          },
          color: statusChartColor,
          data: this.state.statusChartData.sort((a, b) => {
            return b.value - a.value;
          })
          .slice(0, 10),
        },
      ],
    };
    return optionTwo;
  }

  soaHandler = (data) => {
    let selectedSOAItems = data.filter((k, i) => this.state.selectedRowKeys?.includes(k.study_ref_id) && k.soa_status_flag == 'YES') 
    this.props.selectedSOA(selectedSOAItems.length)
    this.setState({ soaData: selectedSOAItems });
    localStorage.setItem('SoaCount', selectedSOAItems.length)
  }

  onRowSelectChange = (selectedRowKeys:any, isClear:any=true) => { 
    if(selectedRowKeys.length == 0) {
      this.props.resetTrials(true)
    } else {
      this.props.resetTrials(false)
    }
    if(isClear && this.state.isPresetsTabSelected) {
      // this.setState({checkedPreset: null });
    }
    if(!this.state.isPresetsTabSelected) {
      this.setState({ selectedRowKeys, selectedPreset:[] });
    }
    this.props.createTrial({
      similarHistoricalTrials: selectedRowKeys,
    });
    localStorage.setItem('newTrial',  JSON.stringify(Object.assign(JSON.parse(localStorage.getItem('newTrial')),{
      similarHistoricalTrials: selectedRowKeys,
    })))
    this.props.handleNewTrialSelectChangeHistory("similarHistoricalTrials", selectedRowKeys)
    const filteredData = this.state.searchedRawData.filter(trial => selectedRowKeys.includes(trial.study_ref_id));
    this.updateMetrics(filteredData);

    this.calculateSummaryMetrics(filteredData)
  };

  onSelectCurrentChange = (item,currentPage) => { 
    if(this.state.checkedPreset && this.state.isPresetsTabSelected) return
    if(item.length == 0) {
      this.props.resetTrials(true)
    } else {
      this.props.resetTrials(false)
    }
    let newSelectedPages = this.state.selectedRowKeys.length === this.state.searchedRawData.length || this.state.isCleared ? [] : [...this.state.selectedPages];
    if (this.state.selectedRowKeys.length === this.state.searchedRawData.length) {
      if (!this.state.selectedPages.includes(currentPage)) {
        newSelectedPages.push(currentPage);
      }
    } else if (!this.state.selectedPages.includes(currentPage)) {
      newSelectedPages.push(currentPage);
    }
 
  let newSelectedRowKeysByPage = {}
  newSelectedRowKeysByPage[currentPage] = item;
  newSelectedPages.forEach((page) => {
    if (this.state.selectedRowKeysByPage[page]) {
      newSelectedRowKeysByPage[page] = this.state.selectedRowKeysByPage[page];
    }
  });
  newSelectedRowKeysByPage[currentPage] = item;
  let newSelectedRowKeys;
  if(this.state.selectedRowKeys.length === this.state.searchedRawData.length){
     newSelectedRowKeys = Object.values(newSelectedRowKeysByPage).flat();
  }else{
    newSelectedRowKeys =  Array.from(new Set([...this.state.selectedRowKeys, ...item]))
  }
  this.setState({ 
    selectedRowKeys: newSelectedRowKeys,
    selectedRowKeysByPage: newSelectedRowKeysByPage,
    selectedPages: newSelectedPages,
    isCleared: false,
  });
   

    this.props.createTrial({
      similarHistoricalTrials: newSelectedRowKeys,
    });
    localStorage.setItem('newTrial',  JSON.stringify(Object.assign(JSON.parse(localStorage.getItem('newTrial')),{
      similarHistoricalTrials: newSelectedRowKeys,
    })))
    this.props.handleNewTrialSelectChangeHistory("similarHistoricalTrials", newSelectedRowKeys);
    const filteredData = this.state.searchedRawData.filter(trial => newSelectedRowKeys.includes(trial.study_ref_id));
    this.updateMetrics(filteredData);
    this.calculateSummaryMetrics(filteredData)
  };
  onSelectAllChange = () => { 
    if(this.state.checkedPreset && this.state.isPresetsTabSelected) return
    const item = [...this.state.searchedData].map((val, index)=>{
      return val.key
    })
    if(item.length == 0) {
      this.props.resetTrials(true)
    } else {
      this.props.resetTrials(false)
    }
    let newSeletedRowKeys = [...item]
    item.forEach((value) => {
      if (!newSeletedRowKeys.includes(value)) {
        newSeletedRowKeys.push(value);
      }
    });    
    this.setState({ selectedRowKeys: newSeletedRowKeys});
    this.props.createTrial({
      similarHistoricalTrials: newSeletedRowKeys,
    });
    localStorage.setItem('newTrial',  JSON.stringify(Object.assign(JSON.parse(localStorage.getItem('newTrial')),{
      similarHistoricalTrials: newSeletedRowKeys,
    })))
    this.props.handleNewTrialSelectChangeHistory("similarHistoricalTrials", newSeletedRowKeys)
    const filteredData = this.state.searchedRawData.filter(trial => newSeletedRowKeys.includes(trial.study_ref_id));
    this.updateMetrics(filteredData);
    this.calculateSummaryMetrics(filteredData)
  };

  onClearPageChange = () => {    
    if(this.state.checkedPreset && this.state.isPresetsTabSelected) return
    const item = [...this.state.searchedData].map((val, index)=>{
      return val.key
    })
    if(item.length == 0) {
      this.props.resetTrials(true)
    } else {
      this.props.resetTrials(false)
    }
    let newSeletedRowKeys = [...this.state.selectedRowKeys]
    item.forEach((value) => {
      newSeletedRowKeys = newSeletedRowKeys.filter((val)=>{
        return val !== value
      })
    });  
    this.setState({ 
      selectedRowKeys: newSeletedRowKeys,
      selectedPages: [],
      isCleared: true 
       });
    this.props.createTrial({
      similarHistoricalTrials: newSeletedRowKeys,
    });
    localStorage.setItem('newTrial',  JSON.stringify(Object.assign(JSON.parse(localStorage.getItem('newTrial')),{
      similarHistoricalTrials: newSeletedRowKeys,
    })))
    this.props.handleNewTrialSelectChangeHistory("similarHistoricalTrials", newSeletedRowKeys);
    const filteredData = this.state.searchedRawData.filter(trial => newSeletedRowKeys.includes(trial.study_ref_id));
    this.updateMetrics(filteredData);
    this.calculateSummaryMetrics(filteredData)
  };

  handleDateChange = (value) => {
    this.setState({
      dateFrom: value[0],
      dateTo: value[1],
    });
  };

  handleValidation = (key, v) => {
    if(key == "indication" && this.state.indication.length < 1){
        this.setState({
            indicationError:"Indication is required."
          })
        return false;
    }else{
        this.setState({
            indicationError:""
          })
    }
    return true;
  };

  handleSearchChange = (column, value) => {
    this.setState((prevState) => ({
      searchValues: {
        ...this.state.searchValues,
        [column]: value,
      },
      lastChangedInput: column,
      shouldAutoFocus: true,
    }), () => {
      this.filterData();
    });
  };
  

  filterData = () => {
    const { searchedRawData, searchValues } = this.state;
    const filtered = searchedRawData.filter((record) => {
      return Object.keys(searchValues).every((key) => {
        const searchValue = searchValues[key].toLowerCase();
        if (!record[key] && searchValue !== "") {
          return false;
        }
        const recordValue = record[key] ? record[key].toString().toLowerCase() : "";
        return recordValue.includes(searchValue);
      })
    });
    this.setState({
      searchedData: filtered,
    });
  };

  calculateSummaryMetrics = (filteredData: any[]) => {
    const patientsPerSitePerMonth = filteredData.map(d => d.patients_per_site_per_month);  
    const numberOfSites = filteredData.map(d => d.number_of_sites);  
    const enrollmentCount = filteredData.map(d => d.enrollment_count);  
    const enrollmentDuration = filteredData.map(d => d.enrollment_duration);  
    const numberOfCountries = filteredData.map(d => d.number_of_countries);  
      
    const metrics_data_list = {  
      patients_per_site_per_month: percentile(patientsPerSitePerMonth, 0.5),  
      number_of_sites: percentile(numberOfSites, 0.5),  
      enrollment_count: percentile(enrollmentCount, 0.5),  
      enrollment_duration: percentile(enrollmentDuration, 0.5),  
      number_of_countries: percentile(numberOfCountries, 0.5),  
    };  
      
    this.setState({ metrics_data_list }); 
  }

  render() {
    const rowSelection = {
      selectedRowKeys: this.state.selectedRowKeys,
      onChange: this.onRowSelectChange,
      columnWidth: 40,
      selections: [
        // Table.SELECTION_ALL,
        {
          key: 'all_page',
          text: 'Select all data',
          onSelect: this.onSelectAllChange
        },
        {
          key: 'current_page',
          text: 'Select current page',
          onSelect: (currentRowKeys) => {
            this.onSelectCurrentChange(currentRowKeys, this.state.current);
          }
        },
        {
          key: 'clear_page',
          text: 'Clear all data',
          onSelect: this.onClearPageChange
        },
        // Table.SELECTION_NONE,
      ], 
      getCheckboxProps: () => ({  
        disabled: this.state.isPresetsTabSelected,  // Disable all checkboxes  
      }),    
      preserveSelectedRowKeys: true,
    };
    const { searchValues } = this.state;

    const searchRow = 
      <tr key="search-row" className="search-row">
        <th></th>
        {columns.map((column) => (
          <th key={column.dataIndex}>
            <div>
              <Input
                className='searched-input'
                ref={(ref) => (this.inputRefs[column.dataIndex] = ref)}
                placeholder={`${column.title}`}
                prefix={<SearchOutlined style={{color: "#666"}}/>}
                value={searchValues[column.dataIndex]}
                onChange={(e) => this.handleSearchChange(column.dataIndex, e.target.value)}
                autoFocus={this.state.shouldAutoFocus && this.props.presetsData?.preset_name?.length == 0 && this.state.lastChangedInput === column.dataIndex}
              />
            </div>
          </th>
        ))}
      </tr>

    // Add a custom row below the original header row
    const CustomHeaderWrapper = ({ children }) => {      
      return <thead>
        {children}
        {searchRow}
        </thead>;
    };

    const constructSummaryTooltip =(fieldName: string) => {
      const filteredTrialData = this.state.searchedData.filter(obj => this.state.selectedRowKeys.includes(obj.study_ref_id));
      return (<>
       <strong className="tooltip-title summary-tooltip-title">Summary</strong>
          <ul className="tooltip-list">
            <li className="tooltip-list-item">
              <span className='hyphen'>-</span>
              <span >Q1 (First Quartile)</span>
              <span className='hyphen'>:</span>
              <span className='activity'>{percentile(getListBypropName(filteredTrialData, fieldName), 0.25)}</span>
            </li>

            <li className="tooltip-list-item">
              <span className='hyphen'>-</span>
              <span >Median</span>
              <span className='hyphen'>:</span>
              <span className='activity'>{percentile(getListBypropName(filteredTrialData, fieldName), 0.5)}</span>
            </li>

            <li className="tooltip-list-item">
              <span className='hyphen'>-</span>
              <span >Mean</span>
              <span className='hyphen'>:</span>
              <span className='activity'>{calculateMean(getListBypropName(filteredTrialData, fieldName))}</span>
            </li>

            <li className="tooltip-list-item">
              <span className='hyphen'>-</span>
              <span >Q3 (Third Quartile)</span>
              <span className='hyphen'>:</span>
              <span className='activity'>{percentile(getListBypropName(filteredTrialData, fieldName), 0.75)}</span>
            </li>
          </ul>
      </>)
    }
    const handleDivClick = (fieldName: string) => {
      this.setState((prevState: any) => ({
        tooltip_visibility: {
          ...prevState.tooltip_visibility,
          fieldName: !prevState.tooltip_visibility[fieldName],
        },
      }));
     
    };
   
    return (
      <div className="historical-trial-list">
        <Row>
          <Col span={this.state.sideBar} className="side-bar">
          {this.state.sideBar !== 6 ? (
            <div className="side-bar-close">
              <div className="filter-button" onClick={() => this.onCloseFilter(6)}>
                <FilterOutlined />
              </div>
            </div>
            ) : (
            <div className="side-bar-filter">
               <CloseOutlined style={{ float: 'right', cursor: 'pointer', padding: 10 }} onClick={() => this.onCloseFilter(1)}/>
                <Tabs activeKey={this.state.activeTab} onChange={this.handleTabChange}>
                 <TabPane tab={(<>Filters</>)} key="1">
                <>
                  <div className="filter-item filter-label">
                  </div>
                  <div className="filter-item">
                    <label>Study phase</label>
                    <Select
                      className='study-phase-select'
                      mode="multiple"
                      allowClear
                      value={this.state.studyPhase || ["All"]}
                      style={{ width: "100%" }}
                      virtual={false}
                      onChange={(e) => this.onSelectChange("studyPhase", e)}
                    >
                      {this.props.studyPhaseList.map((o) => {
                        return (
                          <Option value={o.value} key={o.value}>
                            {o.label}
                          </Option>
                        );
                      })}
                    </Select>
                  </div>
                  <div className="filter-item">
                    <label>Study type</label>
                    <Select
                      mode="multiple"
                      allowClear
                      value={this.state.studyType || ["All"]}
                      style={{ width: "100%" }}
                      virtual={false}
                      onChange={(e) => this.onSelectChange("studyType", e)}
                    >
                      {this.props.studyTypeList.map((o) => {
                        return (
                          <Option value={o.value} key={o.value}>
                            {o.label}
                          </Option>
                        );
                      })}
                    </Select>
                  </div>
                  <div className="filter-item">
                    <label>Study status</label>
                    <Select
                      className='study-status-select'
                      mode="multiple"
                      allowClear
                      value={this.state.studyStatus || ["All"]}
                      style={{ width: "100%" }}
                      virtual={false}
                      onChange={(e) => this.onSelectChange("studyStatus", e)}
                    >
                        {/* <Option value="All" key="All">All</Option> */}
                      {this.props.studyStatusList.map((o) => {
                        return (
                          <Option value={o.value} key={o.value}>
                            {o.label}
                          </Option>
                        );
                      })}
                    </Select>
                  </div>
                  <div className="filter-item">
                    <label>Indication</label>
                    <Select
                      className='indication-select'
                      mode="multiple"
                      // allowClear
                      value={this.state.indication}
                      style={{ width: "100%" }}
                      virtual={false}
                      onBlur={(v) => this.handleValidation("indication", v)}
                      onChange={(e) => this.onSelectChange("indication", e)}
                      onDeselect={(v) => {this.onDeselectChange("indication", v)}}
                      // onClear={this.onClearChange}
                      onMouseLeave={(e) => {
                        this.handleValidation("indication", e) 
                      }}
                      filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    >
                      {this.props.indicationList.length === 0? 
                      this.state.indicationList.map((o) => {
                        return (
                          <Option value={o.value} key={o.value}>
                            {o.label}
                          </Option>
                        );
                      })
                      :this.props.indicationList.map((o) => {
                        return (
                          <Option value={o.value} key={o.value}>
                            {o.label}
                          </Option>
                        );
                      })
                    }
                    </Select>
                    <br/>
                    <span className="trial-historical-trial-error">{this.state.indicationError}</span>
                    {/* Indication is required */}
                  </div>

                  <div className="filter-item indication-wrapper">
                    <label>Include trials with additional conditions</label>
                    <Switch className="switch-class"  onChange={(e) => this.changeToggleHandler(e)} checked={this.state.toggle_indication} />
                  </div>
                  <div className="filter-item">
                    <label>Schedule of activities (SoA)</label>
                    <Select
                      className= 'soa-value'
                      value={this.state.soaFlag === null ? "null" : this.state.soaFlag?.toString()}
                      style={{ width: "100%" }}
                      onChange={(e) =>{ 
                        let inputValue = e === 'null' ? null : e;
                        this.onSelectChange("soaFlag", inputValue)}}
                    >
                        <Option value="null" key="null">All</Option>
                        <Option value="YES" key="YES">Yes</Option>
                        {/* <Option value="NO" key="NO">No</Option> */}
                    </Select>
                  </div>
                  <div className="filter-item">
                    <label>Pediatric</label>
                    <Select
                      value={this.state.pediatric === null ? "null" : this.state.pediatric?.toString()}
                      style={{ width: "100%" }}
                      onChange={(e) => {
                        let inputValue = e === 'null' ? null : e === 'true' ? true : false;
                        this.onSelectChange("pediatric", inputValue)}
                      }
                    >
                        <Option value="null" key="null">All</Option>
                        <Option value="true" key="true">Yes</Option>
                        <Option value="false" key="false">No</Option>
                    </Select>
                  </div>
                  <div className="filter-item">
                    <label>MoA</label>
                    <Select
                      mode="multiple"
                      allowClear
                      value={this.state.selectedMoa || []}
                      style={{ width: "100%" }}
                      virtual={false}
                      autoClearSearchValue={false}
                      // onBlur={(v) => this.handleValidation("indication", v)}
                      onChange={(e) => this.onSelectChange("selectedMoa", e)}
                    >
                      {this.state?.moaDataList?.map((o) => {
                        return (
                          <Option value={o} key={o}>
                            {o}
                          </Option>
                        );
                      })}
                    </Select>
                  </div>
                  <div className="filter-item">
                    <label>Patient segment  <Tooltip 
                  overlayInnerStyle={{width: '400px'}}
                  placement="right"
                  // visible={true}
                  title={'Patient Segment information is taken as-is from TrialTrove. Please verify the information for critical trial filtering'}
                  >
                    <InfoCircleOutlined style={{marginLeft: 10, verticalAlign: 'middle'}}/>
                  </Tooltip> </label>
                    <Select
                      mode="multiple"
                      allowClear
                      value={this.state.selectedPs || []}
                      style={{ width: "100%" }}
                      virtual={false}
                      autoClearSearchValue={false}
                      // onBlur={(v) => this.handleValidation("indication", v)}
                      onChange={(e) => this.onSelectChange("selectedPs", e)}
                    >
                      {this.state?.patientSegmentDataList?.map((o) => {
                        return (
                          <Option value={o} key={o}>
                            {o}
                          </Option>
                        );
                      })}
                    </Select>
                  </div>
                  <div className="filter-item">
                    <label>Study start date</label>
                    <Slider
                      className="sht-slider"
                      min={min}
                      max={max}
                      range={{ draggableTrack: true }}
                      marks={marks}
                      dots
                      value={[this.state.dateFrom, this.state.dateTo]}
                      onChange={this.handleDateChange}
                    />
                  </div>
                  <div className="filter-item find-trial-btn-wrapper">
                    <Button disabled={!(this.state.indication.length > 0) || this.state.spinning? true : false} onClick={()=>this.onFindTrials(true)}>
                      Find trials
                    </Button>
                  </div>
                  </>
                 </TabPane>
                 <TabPane tab='Presets' key="2"> 
                    <> 
                      <Radio.Group 
                        options={this.props.getPresets?.map((option) => ({ 
                        label: (  
                          <>
                          <Tooltip title={`${option.description}`} placement="topLeft">
                            <span className="preset-name">  
                              {option.preset_name}
                            </span> 
                          </Tooltip>
                            <br />
                            <span className="preset-count-conatiner">Trials: <span className="preset-count">{option.total_study_count}</span>: Trials with SoA: <span className="preset-count">{option.soa_study_count}</span>; <br />
                            <span className="presets-created-by">Created by: <span className="presets-created-name"> {option.created_by}  </span> </span>
                            <br />
                            <br />
                          </span>  
                          </>
                        ),  
                        value: option.preset_id, ...option }))}
                        onChange={this.onChangePresets} value={this.state.checkedPreset}
                      >  
                    </Radio.Group>  
                    </>
                  </TabPane>
                 </Tabs>
              
            </div>
            )}
          </Col>

          <Col span={24 - this.state.sideBar} className="historical-desc">
            <Spin spinning={this.state.spinning} >
              <div className="title">Similar historical trials</div>
              <div className="title-desc">Select the similar historical trials used to calculate metric benchmarks for your trial</div>
             {this.state.selectedPreset?.length > 0 && ( <div className="title-preset-display">{this.state.selectedPreset[0]?.preset_name}</div>)}
              <div className="count-wrapper">
              <div className="summary-count">
                  {this.state.selectedRowKeys && this.state.selectedRowKeys.length}
                  <span className="num-desc">&nbsp;Number of trials</span>
                </div>
                <div className="summary-count">
                  {this.state.soaData && this.state.soaData.length}
                  <span className="num-desc">&nbsp;Number of trials with Schedule of Activities data</span>
                </div>
              </div>

               <Row className="chart-wrapper-row">
                 <div className="chart-wrapper">
                <Col span={6}>
                  <ReactECharts option={this.getOptionOne()} style={{height:"200px"}}></ReactECharts>
                </Col>
                <Col span={6}>
                <div className="my-legend-wrapper">
                  {
                    this.state.sponsorChartData.sort((a,b)=>{
                      return b.value -a.value
                    }).slice(0,5).map( (d,idx)=>{
                      const chartData = this.state.sponsorChartData
                      const sum = chartData.reduce((accumulator, currentValue) => {
                       return accumulator + currentValue.value
                      }, 0)
                      let percent = ((d.value / sum) * 100).toFixed(2);
                      return(
                        <div className="custom-legend" key={d.name}>
                        <span className="my_legend" style={{'backgroundColor':sponsorChartColor[idx]}}></span><i className="my_legend_text">{`${d.name} - ${percent}%`}</i>
                      </div>
                      )
                    })
                  }
                </div>
                </Col>
                <Col span={6}>  <ReactECharts option={this.getOptionTwo()} style={{height:"200px"}}></ReactECharts>  </Col>
                <Col span={6}>

                  <div className="my-legend-wrapper">
                        {
                          this.state.statusChartData.sort((a,b)=>{
                            return b.value -a.value
                          }).slice(0,5).map( (d,idx)=>{
                            const chartData = this.state.statusChartData
                            const sum = chartData.reduce((accumulator, currentValue) => {
                            return accumulator + currentValue.value
                            }, 0)
                            let percent = ((d.value / sum) * 100).toFixed(2);
                            return(
                              <div className="custom-legend" key={d.name}>
                              <span className="my_legend" style={{'backgroundColor':statusChartColor[idx]}}></span><i className="my_legend_text">{`${d.name} - ${percent}%`}</i>
                            </div>
                            )
                          })
                        }
                      </div>
                </Col>
              </div>
              </Row>
              {
                 this.props.isUpdate &&  <div className="update-warning">All downstream scenario metrics will be affected by updating your similar trial list.</div>
               }
              <Row className="metrics-wrapper">
                  <Tooltip
                      title={<div className="tooltip-content">
                       {constructSummaryTooltip('number_of_sites')}
                        </div>
                      }
                      visible={this.state.tooltip_visibility.siteTooltipVisible}
                      onVisibleChange={(newVisible) => { this.setState({
                        tooltip_visibility: {
                          ...this.state.tooltip_visibility,
                          siteTooltipVisible: newVisible,
                        },
                      });}}
                      trigger="click"
                      overlayInnerStyle={{ backgroundColor: '#f5f5f5', color: 'black', border: '1px solid #d9d9d9', borderRadius: '20%' }}
                  >
                  <div className="metric" onClick = {() => handleDivClick('siteTooltipVisible')}>
                    <div className="metric-value">
                    {roundToTwoDecimals(this.state.metrics_data_list?.number_of_sites)}
                    </div>
                    <div className="metric-desc">
                      Number of Sites
                    </div>
                  </div>
                </Tooltip>
                <Tooltip
                    title={<div className="tooltip-content">
                      {constructSummaryTooltip('enrollment_count')}
                      </div>
                    }
                    visible={this.state.tooltip_visibility.patientTooltipVisible}
                    onVisibleChange={(newVisible) => { this.setState({
                        tooltip_visibility: {
                          ...this.state.tooltip_visibility,
                          patientTooltipVisible: newVisible,
                        },
                      });}}
                    trigger="click"
                    overlayInnerStyle={{ backgroundColor: '#f5f5f5', color: 'black', border: '1px solid #d9d9d9', borderRadius: '20%' }}
                  >
                  <div className="metric"  onClick = {() => handleDivClick('patientTooltipVisible')}>
                    <div className="metric-value">
                    {roundToTwoDecimals(this.state.metrics_data_list?.enrollment_count)}
                    </div>
                    <div className="metric-desc">
                      Number of Patients
                    </div>
                  </div>
                </Tooltip>
                <Tooltip
                    title={<div className="tooltip-content">
                      {constructSummaryTooltip('number_of_countries')}
                      </div>
                    }
                    visible={this.state.tooltip_visibility.countryTooltipVisible}
                    onVisibleChange={(newVisible) => { this.setState({
                        tooltip_visibility: {
                          ...this.state.tooltip_visibility,
                          countryTooltipVisible: newVisible,
                        },
                      });}}
                    trigger="click"
                    overlayInnerStyle={{ backgroundColor: '#f5f5f5', color: 'black', border: '1px solid #d9d9d9', borderRadius: '20%' }}
                  >
                  <div className="metric" onClick = {() => handleDivClick('countryTooltipVisible')}>
                    <div className="metric-value">
                    {roundToTwoDecimals(this.state.metrics_data_list?.number_of_countries)}
                    </div>
                    <div className="metric-desc">
                      Number of Countries
                    </div>
                  </div>
               </Tooltip>
               <Tooltip
                    title={<div className="tooltip-content">
                      {constructSummaryTooltip('enrollment_duration')}
                      </div>
                    }
                    visible={this.state.tooltip_visibility.enrollmentDurationTooltipVisible}
                    onVisibleChange={(newVisible) => { this.setState({
                        tooltip_visibility: {
                          ...this.state.tooltip_visibility,
                          enrollmentDurationTooltipVisible: newVisible,
                        },
                      });}}
                    trigger="click"
                    overlayInnerStyle={{ backgroundColor: '#f5f5f5', color: 'black', border: '1px solid #d9d9d9', borderRadius: '20%' }}
                  >
                  <div className="metric" onClick = {() => handleDivClick('enrollmentDurationTooltipVisible')}>
                    <div className="metric-value">
                    {roundToTwoDecimals(this.state.metrics_data_list?.enrollment_duration)}
                    </div>
                    <div className="metric-desc">
                      Enrollment Duration (in months)
                    </div>
                  </div>
                </Tooltip>
                <Tooltip
                    title={<div className="tooltip-content">
                      {constructSummaryTooltip('patients_per_site_per_month')}
                      </div>
                    }
                    visible={this.state.tooltip_visibility.enrollmentSpeedTooltipVisible}
                    onVisibleChange={(newVisible) => { this.setState({
                        tooltip_visibility: {
                          ...this.state.tooltip_visibility,
                          enrollmentSpeedTooltipVisible: newVisible,
                        },
                      });}}
                    trigger="click"
                    overlayInnerStyle={{ backgroundColor: '#f5f5f5', color: 'black', border: '1px solid #d9d9d9', borderRadius: '20%' }}
                  >
                  <div className="metric" onClick = {() => handleDivClick('enrollmentSpeedTooltipVisible')}>
                    <div className="metric-value">
                    {roundToTwoDecimals(this.state.metrics_data_list?.patients_per_site_per_month)}
                    </div>
                    <div className="metric-desc">
                      Enrollment Speed (PSM)
                    </div>
                  </div>
                </Tooltip>
              </Row>
              <Row>
                <Table
                  columns={columns}
                  dataSource={this.state.searchedData}
                  pagination={{
                    position: ["bottomRight"],
                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${this.state.searchedData.length} items`,
                    defaultPageSize: 10,
                    pageSizeOptions:[ "10", "20", "50", "100"],
                    onChange: this.changePage,
                    current: this.state.current,
                    total: this.state.searchedData.length,
                    showSizeChanger: true,
                    onShowSizeChange: this.onShowSizeChange,
                    // pageSizeOptions: this.state.pageSizeOptions
                  }}
                  // sticky
                  // scroll={{y: 300}}
                  scroll={{ x: 1400 }}
                  rowSelection={rowSelection}
                  // Rewrite the header of the Table to add a custom searching row
                  components={{
                    header: {
                      wrapper: CustomHeaderWrapper,
                    },
                  }}
                />
              </Row>
            </Spin>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  createTrial: (val) => dispatch(createActions.createTrial(val)),
  fetchHistory:(val) => dispatch(historyActions.fetchHistory(val)),
});

const mapStateToProps = (state) => ({
  newTrial: state.trialReducer,
  historyTrial:state.historyReducer,
  getPresets: state.presetsReducer,
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SimilarHistoricalTrial);
